import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	pageHeading: {
		id: 'fastshift-portal.cs-profiler.page-heading',
		defaultMessage: 'Cloud Migration Security & Compliance Blocker Profiler',
		description: 'Heading for the CS Profiler page in FastShift Portal.',
	},
	pageDescription: {
		id: 'fastshift-portal.cs-profiler.page-description',
		defaultMessage:
			'Select a customer profile to surface statistically likely blockers and recommended mitigations.',
		description: 'Description for the CS Profiler page in FastShift Portal.',
	},
	regionLabel: {
		id: 'fastshift-portal.cs-profiler.region-label',
		defaultMessage: 'Region',
		description: 'Label for the CS Profiler region filter.',
	},
	regionPlaceholder: {
		id: 'fastshift-portal.cs-profiler.region-placeholder',
		defaultMessage: 'Region',
		description: 'Placeholder for the CS Profiler region filter.',
	},
	industryLabel: {
		id: 'fastshift-portal.cs-profiler.industry-label',
		defaultMessage: 'Industry',
		description: 'Label for the CS Profiler industry filter.',
	},
	industryPlaceholder: {
		id: 'fastshift-portal.cs-profiler.industry-placeholder',
		defaultMessage: 'Industry',
		description: 'Placeholder for the CS Profiler industry filter.',
	},
	segmentLabel: {
		id: 'fastshift-portal.cs-profiler.segment-label',
		defaultMessage: 'Segment',
		description: 'Label for the CS Profiler segment filter.',
	},
	segmentPlaceholder: {
		id: 'fastshift-portal.cs-profiler.segment-placeholder',
		defaultMessage: 'Segment',
		description: 'Placeholder for the CS Profiler segment filter.',
	},
	amerRegionOption: {
		id: 'fastshift-portal.cs-profiler.amer-region-option',
		defaultMessage: 'AMER (Americas)',
		description: 'Option label for the CS Profiler AMER region filter value.',
	},
	emeaRegionOption: {
		id: 'fastshift-portal.cs-profiler.emea-region-option',
		defaultMessage: 'EMEA (Europe, Middle East & Africa)',
		description: 'Option label for the CS Profiler EMEA region filter value.',
	},
	apacRegionOption: {
		id: 'fastshift-portal.cs-profiler.apac-region-option',
		defaultMessage: 'APAC (Asia-Pacific)',
		description: 'Option label for the CS Profiler APAC region filter value.',
	},
	smbSegmentOption: {
		id: 'fastshift-portal.cs-profiler.smb-segment-option',
		defaultMessage: 'SMB (incl. SMB plus)',
		description: 'Option label for the CS Profiler SMB segment filter value.',
	},
	governmentSegmentOption: {
		id: 'fastshift-portal.cs-profiler.government-segment-option',
		defaultMessage: 'Government / Public Sector',
		description: 'Option label for the CS Profiler government segment filter value.',
	},
	profileButton: {
		id: 'fastshift-portal.cs-profiler.profile-button',
		defaultMessage: 'Profile this customer',
		description: 'Button text for profiling the selected CS Profiler filters.',
	},
	profilingOptionsError: {
		id: 'fastshift-portal.cs-profiler.profiling-options-error',
		defaultMessage: 'We could not load the profiler filters. Refresh the page to try again.',
		description: 'Error message shown when CS Profiler filter options fail to load.',
	},
	customerProfileError: {
		id: 'fastshift-portal.cs-profiler.customer-profile-error',
		defaultMessage: 'We could not profile this customer. Try again.',
		description: 'Error message shown when CS Profiler customer profile fails to load.',
	},
	emptyStateHeading: {
		id: 'fastshift-portal.cs-profiler.empty-state-heading',
		defaultMessage: 'Select a region, industry, and segment',
		description: 'Heading shown before a CS Profiler profile has been selected.',
	},
	emptyStateDescription: {
		id: 'fastshift-portal.cs-profiler.empty-state-description',
		defaultMessage:
			'Choose all three profile fields, then select Profile this customer to see predicted blockers and recommendations.',
		description: 'Description shown before a CS Profiler profile has been selected.',
	},
	resultsHeading: {
		id: 'fastshift-portal.cs-profiler.results-heading',
		defaultMessage: 'Predicted Security & Compliance Blockers',
		description: 'Heading for CS Profiler results.',
	},
	resultSummary: {
		id: 'fastshift-portal.cs-profiler.result-summary',
		defaultMessage:
			'Found {totalItems, plural, one {# item} other {# items}} for this customer profile ({blockerCount, plural, one {# requires} other {# require}} attention, {watchCount} to review).',
		description: 'Summary of CS Profiler results.',
	},
	selectedProfileSummary: {
		id: 'fastshift-portal.cs-profiler.selected-profile-summary',
		defaultMessage: '{region} - {industry} - {segment}',
		description: 'Selected profile summary shown above CS Profiler theme results.',
	},
	exportToConfluenceButton: {
		id: 'fastshift-portal.cs-profiler.export-to-confluence-button',
		defaultMessage: 'Export to Confluence',
		description: 'Button text for exporting CS Profiler results to Confluence.',
	},
	exportSuccessFlagTitle: {
		id: 'fastshift-portal.cs-profiler.export-success-flag-title',
		defaultMessage: 'Copied the formatted snapshot to your clipboard.',
		description: 'Flag title shown after CS Profiler results are copied for Confluence.',
	},
	exportSuccessFlagDescription: {
		id: 'fastshift-portal.cs-profiler.export-success-flag-description',
		defaultMessage:
			'Create a new Confluence page, then paste the copied profile snapshot into the editor.',
		description: 'Flag description shown after CS Profiler results are copied for Confluence.',
	},
	exportSuccessFlagAction: {
		id: 'fastshift-portal.cs-profiler.export-success-flag-action',
		defaultMessage: 'Create page in {spaceKey}',
		description: 'Flag action text linking to a new Confluence page.',
	},
	exportErrorFlagTitle: {
		id: 'fastshift-portal.cs-profiler.export-error-flag-title',
		defaultMessage: 'Could not access the clipboard.',
		description: 'Flag title shown when CS Profiler results cannot be copied.',
	},
	exportErrorFlagDescription: {
		id: 'fastshift-portal.cs-profiler.export-error-flag-description',
		defaultMessage: 'Please grant clipboard permission and try again.',
		description: 'Flag description shown when CS Profiler results cannot be copied.',
	},
	exportPreparationErrorFlagTitle: {
		id: 'fastshift-portal.cs-profiler.export-preparation-error-flag-title',
		defaultMessage: 'Could not prepare the export.',
		description: 'Flag title shown when CS Profiler results cannot be prepared for export.',
	},
	exportPreparationErrorFlagDescription: {
		id: 'fastshift-portal.cs-profiler.export-preparation-error-flag-description',
		defaultMessage: 'Refresh the results and try exporting again.',
		description: 'Flag description shown when CS Profiler results cannot be prepared for export.',
	},
	linkedTicketsButton: {
		id: 'fastshift-portal.cs-profiler.linked-tickets-button',
		defaultMessage: 'Linked Tickets in Atlassian Roadmap',
		description: 'Button text for showing linked CS Profiler roadmap tickets.',
	},
	linkedTicketsLoading: {
		id: 'fastshift-portal.cs-profiler.linked-tickets-loading',
		defaultMessage: 'Loading linked tickets.',
		description: 'Message shown while linked CS Profiler tickets are loading.',
	},
	linkedTicketsError: {
		id: 'fastshift-portal.cs-profiler.linked-tickets-error',
		defaultMessage: 'We could not load linked tickets. Try again.',
		description: 'Error message shown when linked CS Profiler tickets fail to load.',
	},
	noLinkedTickets: {
		id: 'fastshift-portal.cs-profiler.no-linked-tickets',
		defaultMessage: 'No linked tickets were found for this theme.',
		description: 'Empty state shown when a CS Profiler theme has no linked tickets.',
	},
	entTicketsHeading: {
		id: 'fastshift-portal.cs-profiler.ent-tickets-heading',
		defaultMessage: 'ENT tickets ({count})',
		description: 'Heading for linked ENT tickets in CS Profiler theme details, including count.',
	},
	jpdTicketsHeading: {
		id: 'fastshift-portal.cs-profiler.jpd-tickets-heading',
		defaultMessage: 'JPD tickets ({count})',
		description: 'Heading for linked JPD tickets in CS Profiler theme details, including count.',
	},
	entTicketsTableCaption: {
		id: 'fastshift-portal.cs-profiler.ent-tickets-table-caption',
		defaultMessage: 'Linked ENT tickets for {themeName}',
		description: 'Accessible table caption for linked ENT tickets in CS Profiler.',
	},
	jpdTicketsTableCaption: {
		id: 'fastshift-portal.cs-profiler.jpd-tickets-table-caption',
		defaultMessage: 'Linked JPD tickets for {themeName}',
		description: 'Accessible table caption for linked JPD tickets in CS Profiler.',
	},
	ticketKeyColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-key-column-heading',
		defaultMessage: 'Key',
		description: 'Column heading for linked ticket key.',
	},
	ticketSummaryColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-summary-column-heading',
		defaultMessage: 'Summary',
		description: 'Column heading for linked ticket summary.',
	},
	ticketPriorityColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-priority-column-heading',
		defaultMessage: 'Priority',
		description: 'Column heading for linked ENT ticket priority.',
	},
	ticketStatusColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-status-column-heading',
		defaultMessage: 'Status',
		description: 'Column heading for linked ticket status.',
	},
	ticketTargetDateColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-target-date-column-heading',
		defaultMessage: 'Target date',
		description: 'Column heading for linked ENT ticket target date.',
	},
	ticketUpdatedColumnHeading: {
		id: 'fastshift-portal.cs-profiler.ticket-updated-column-heading',
		defaultMessage: 'Updated',
		description: 'Column heading for linked JPD ticket updated date.',
	},
	noTicketValue: {
		id: 'fastshift-portal.cs-profiler.no-ticket-value',
		defaultMessage: 'Not set',
		description: 'Fallback text for an unavailable linked ticket value.',
	},
	blockerSectionHeading: {
		id: 'fastshift-portal.cs-profiler.blocker-section-heading',
		defaultMessage: 'Items to resolve before migration',
		description: 'Section heading for CS Profiler blocker themes.',
	},
	blockerSectionDescription: {
		id: 'fastshift-portal.cs-profiler.blocker-section-description',
		defaultMessage: 'Might be a migration blocker',
		description: 'Description for CS Profiler blocker themes.',
	},
	watchSectionHeading: {
		id: 'fastshift-portal.cs-profiler.watch-section-heading',
		defaultMessage: 'Items that need attention',
		description: 'Section heading for CS Profiler themes that need attention.',
	},
	watchSectionDescription: {
		id: 'fastshift-portal.cs-profiler.watch-section-description',
		defaultMessage: 'Review recommended, but migration can proceed',
		description: 'Description for CS Profiler themes that need attention.',
	},
	noThemes: {
		id: 'fastshift-portal.cs-profiler.no-themes',
		defaultMessage: 'No blocker themes were found for this customer profile.',
		description: 'Empty state shown when CS Profiler returns no themes.',
	},
	expandThemeLabel: {
		id: 'fastshift-portal.cs-profiler.expand-theme-label',
		defaultMessage: 'Show details for {themeName}',
		description: 'Accessible label for expanding a CS Profiler theme row.',
	},
	collapseThemeLabel: {
		id: 'fastshift-portal.cs-profiler.collapse-theme-label',
		defaultMessage: 'Hide details for {themeName}',
		description: 'Accessible label for collapsing a CS Profiler theme row.',
	},
	themeInfoLabel: {
		id: 'fastshift-portal.cs-profiler.theme-info-label',
		defaultMessage: 'Theme details',
		description: 'Tooltip content for a CS Profiler theme info icon.',
	},
	themeInfoButtonLabel: {
		id: 'fastshift-portal.cs-profiler.theme-info-button-label',
		defaultMessage: 'Show theme details for {themeName}',
		description: 'Accessible label for a CS Profiler theme info icon button.',
	},
	insightsHeading: {
		id: 'fastshift-portal.cs-profiler.insights-heading',
		defaultMessage: 'INSIGHTS',
		description: 'Heading for CS Profiler theme insights.',
	},
	recommendationsHeading: {
		id: 'fastshift-portal.cs-profiler.recommendations-heading',
		defaultMessage: 'RECOMMENDATIONS',
		description: 'Heading for CS Profiler theme recommendations.',
	},
	industryInsight: {
		id: 'fastshift-portal.cs-profiler.industry-insight',
		defaultMessage:
			'Customers in the <bold>{industry}</bold> industry face this problem <bold>{percentage}%</bold> of the time',
		description: 'Insight copy when a CS Profiler theme is predicted by industry.',
	},
	regionIndustryInsight: {
		id: 'fastshift-portal.cs-profiler.region-industry-insight',
		defaultMessage:
			'Customers within <bold>{region}</bold> region and <bold>{industry}</bold> industry face this problem <bold>{percentage}%</bold> of the time',
		description: 'Insight copy when a CS Profiler theme is predicted by region and industry.',
	},
	segmentInsight: {
		id: 'fastshift-portal.cs-profiler.segment-insight',
		defaultMessage:
			'<bold>{segment}</bold> customers face this problem <bold>{percentage}%</bold> of the time.',
		description: 'Insight copy when a CS Profiler theme is predicted by segment.',
	},
	regionSegmentInsight: {
		id: 'fastshift-portal.cs-profiler.region-segment-insight',
		defaultMessage:
			'<bold>{segment}</bold> customers in <bold>{region}</bold> face this problem <bold>{percentage}%</bold> of the time.',
		description: 'Insight copy when a CS Profiler theme is predicted by region and segment.',
	},
	baseRateInsight: {
		id: 'fastshift-portal.cs-profiler.base-rate-insight',
		defaultMessage:
			'All migrating customers face this problem <bold>{percentage}%</bold> of the time, regardless of profile.',
		description: 'Insight copy when a CS Profiler theme is included by global base rate.',
	},
	noInsights: {
		id: 'fastshift-portal.cs-profiler.no-insights',
		defaultMessage: 'No insights are available for this theme.',
		description: 'Fallback text when a CS Profiler theme has no insight data.',
	},
});
